import { render } from "./TkEngagementInsightDraft.vue?vue&type=template&id=16b512b4&scoped=true"
import script from "./TkEngagementInsightDraft.vue?vue&type=script&lang=js"
export * from "./TkEngagementInsightDraft.vue?vue&type=script&lang=js"

import "./TkEngagementInsightDraft.vue?vue&type=style&index=0&id=16b512b4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b512b4"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QInput,QIcon,QCardActions,QBtn,QField});
